import { React } from "react";

const Tab = (props) => {
  return (
    <div className="mt-6">
      <div className="grid gap-2 text-sm">
        {props.data.map((tab, idx) => {
          return (
            <button
              key={idx}
              className={`border-b-2 px-2 text-md transition-colors duration-300 ${
                idx === props.activeTab
                  ? "border-white text-white"
                  : "border-none text-white"
              }`}
              onClick={() => props.handlechange(idx)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Tab;
